import { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';

export const useGetDeliveryAndStoreZip = () => {

  const experienceContext = useContext(ExperienceContext);
  const { storeId, storeZip } = useStore() || {};
  const deliveryZip = experienceContext?.deliveryZip;

  return { storeId, storeZip, deliveryZip };

};